import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutConfirmDialog',
  props: {
  forActivation: {
    type: Boolean,
    required: true,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
  titleText: {
    type: String,
    required: true,
  },
},
  emits: ['closeDialog', 'openDialog'],
  setup(__props, { emit: emits }) {

const props = __props;

const m = defineMessages({
  authSetupComplete:
    '二要素認証の設定が完了しました。セキュリティのため一度ログアウトが必要です。次回ログイン時には、設定した二要素認証を使ってログインしてください。',
  logoutButton: 'ログアウトする',
});





const handleConfirmAction = () => {
  emits('openDialog');
};

const visible = computed(() => props.isOpen);

return { __sfc: true,m, props, emits, handleConfirmAction, visible }
}

})